// src/components/TranslationsClientProvider.tsx
import React, { ReactNode } from "react";
import { TranslationsProvider } from "@/context/TranslationsContext";
import type { Language } from "@/translations/supportedLanguages";
import LangSetter from "./LangSetter";

interface Props {
  children: ReactNode;
  initialLanguage: Language;
  messages?: Record<string, string>;
}

const TranslationsClientProvider: React.FC<Props> = ({
  children,
  initialLanguage,
  messages,
}) => (
  <TranslationsProvider initialLanguage={initialLanguage} messages={messages}>
    <LangSetter />
    {children}
  </TranslationsProvider>
);

export default TranslationsClientProvider;
